import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Card, CardText, CardBody, CardTitle, Button } from 'reactstrap';
import Actions from "./Actions";

import { choice } from './styles/Choice.module.scss';

export default class Choice extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.node,
    children: PropTypes.node,
    icon: PropTypes.node,
    onSelect: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  onSelectEvent = event => {
    event.preventDefault();
    this.props.onSelect(event);
  };

  render() {
    const { title, text, icon, children, className, ...props } = this.props;

    return (
      <Card {...props} className={classNames(choice, className)}>
        {icon}

        <CardBody>
          <CardTitle>{title}</CardTitle>
          {text && <CardText>{text}</CardText>}
          <p className="card-accent-message">{children}</p>

          <Actions>
            <Button color="primary" onClick={this.onSelectEvent}>
              Select
            </Button>
          </Actions>
        </CardBody>
      </Card>
    );
  }
}
